import PropTypes from "prop-types";

export const DynamicContentRenderer = ({
  htmlContent,
  isLoading,
  error,
  loadingMessage = "Loading content...",
  errorMessage,
  containerClass,
  contentClass,
}) => {
  if (isLoading) {
    return <div className={containerClass}>{loadingMessage}</div>;
  }

  if (error) {
    return (
      <div className={containerClass}>{errorMessage || `Error: ${error}`}</div>
    );
  }

  return (
    <div className={containerClass}>
      <div
        className={contentClass}
        dangerouslySetInnerHTML={{ __html: htmlContent || "" }}
      />
    </div>
  );
};

DynamicContentRenderer.propTypes = {
  htmlContent: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  loadingMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  containerClass: PropTypes.string,
  contentClass: PropTypes.string,
};
